import React, {useEffect, useState} from "react";
import {api} from "../utils/gashtaltAPI";
import Loader from "../components/Loader";
import ErrorPage from "../components/ErrorPage";
import Navbar from "../components/Navbar";
import {useParams} from "react-router-dom";
import {toPersianNumber} from "../utils/numberConversion";

function ResultById() {
    const {userId,examId} = useParams();
    const [report, setReport] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [error, setError] = useState(null);
    const [loading,setLoading] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get(`/api/exam/resultById/${userId}/${examId}`);
                setReport(response.data.data);

            } catch (error) {
                setError(error)
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get(`/api/exam/answersById/${userId}/${examId}`);
                setAnswers(response.data.data);
            } catch (error) {
                setError(error)
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);

    if (loading) return <Loader />
    if (error) return <ErrorPage error={error}/>;
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="result-container flex-fill d-flex flex-column justify-content-between">
                <div className="result">
                    <h2 className={'text-center'}>{report?.exam_name}</h2>
                    <h6 className="text-center py-2 correct-answer">
                         کاربر
                        <span className={"mx-1"}>{toPersianNumber(report?.name)}</span>
                    </h6>
                    <div className={'row result-detail'}>
                        <p className={"col-12 col-lg-4 text-center"}>
                            تعداد کل سوالات :
                            {toPersianNumber(report?.total_question_count)}
                        </p>
                        <p className="correct-answer col-6 col-lg-4">
                            پاسخ های صحیح :
                            {toPersianNumber(report?.correct_answers)}
                        </p>
                        <p className="wrong-answer col-6 col-lg-4">
                            پاسخ های غلط :
                            {toPersianNumber(report?.wrong_answers)}
                        </p>
                    </div>
                    <div className={'row result-detail'}>
                        <p className={"col-12 col-lg-4 "+ (report?.score > 0 ? 'correct-answer' : 'wrong-answer')}>
                            درصد پاسخگویی :
                            <span className="mx-1">{toPersianNumber(report?.score)}</span>
                            <span className="mx-1">درصد</span>
                        </p>
                        <p className={"col-12 col-lg-4"}>
                            تعداد کل شرکت کنندگان :
                            {toPersianNumber(report?.participants)}
                        </p>
                        <p className={"col-12 col-lg-4"}>
                            رتبه کاربر   :
                            {toPersianNumber(report?.rank)}
                        </p>
                    </div>
                    <ul className="modal-options">
                        {answers.map((question, index) => question !== null ? (
                            <li key={index} className="d-flex flex-row justify-content-center align-items-center">
                                <h4>سوال {toPersianNumber(index + 1)} : </h4>
                                {question.optionCount.map((id, i) => (
                                    <span key={id}
                                          className={
                                              `option counter ${id === question.correct && id === question.userSelected ? 'selected' : ''}
                                         ${id !== question.correct && id === question.userSelected ? 'wrong-answer' : ''}
                                         ${id === question.correct && id !== question.userSelected ? 'correct-answer' : ''}
                                         `}>
                                        <div>{toPersianNumber(i + 1)}</div>
                                    </span>
                                ))}
                            </li>
                        ) : null)}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default ResultById;